import { useState } from 'react';
import { Mail, Phone, MapPin, ArrowRight } from 'lucide-react';
import ScrollReveal from '../components/ScrollReveal';

const contactInfo = [
  {
    icon: <Mail size={20} />,
    title: 'Email',
    text: 'hola@markagencia.com',
  },
  {
    icon: <Phone size={20} />,
    title: 'Teléfono',
    text: '+52 55 1234 5678',
  },
  {
    icon: <MapPin size={20} />,
    title: 'Ubicación',
    text: 'Ciudad de México, México',
  },
];

export default function Contact() {
  const [form, setForm] = useState({ name: '', email: '', message: '' });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
    setForm({ name: '', email: '', message: '' });
    setTimeout(() => setSubmitted(false), 4000);
  };

  return (
    <div className="page">
      <section className="section">
        <div className="container">
          <ScrollReveal>
            <span className="section-label">Contacto</span>
          </ScrollReveal>
          <ScrollReveal delay={0.1}>
            <h1 className="section-title">
              Hablemos de tu<br />
              <span className="gradient-text">próximo proyecto.</span>
            </h1>
          </ScrollReveal>
          <ScrollReveal delay={0.2}>
            <p className="section-subtitle">
              ¿Listo para transformar tu marca? Escríbenos y te responderemos
              en menos de 24 horas.
            </p>
          </ScrollReveal>

          <div className="contact-grid">
            <ScrollReveal delay={0.1}>
              <form className="contact-form" onSubmit={handleSubmit}>
                <div className="form-group">
                  <label htmlFor="name">Nombre</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    placeholder="Tu nombre completo"
                    value={form.name}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="email">Email</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    placeholder="tu@email.com"
                    value={form.email}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="message">Mensaje</label>
                  <textarea
                    id="message"
                    name="message"
                    placeholder="Cuéntanos sobre tu proyecto..."
                    value={form.message}
                    onChange={handleChange}
                    required
                  />
                </div>

                <button type="submit" className="btn btn-primary">
                  Enviar mensaje <ArrowRight size={18} />
                </button>

                {submitted && (
                  <div className="form-success">
                    ¡Mensaje enviado con éxito! Te contactaremos pronto.
                  </div>
                )}
              </form>
            </ScrollReveal>

            <ScrollReveal delay={0.25} direction="left">
              <div className="contact-info">
                {contactInfo.map(({ icon, title, text }) => (
                  <div className="contact-info-item" key={title}>
                    <div className="contact-icon">{icon}</div>
                    <div>
                      <h4>{title}</h4>
                      <p>{text}</p>
                    </div>
                  </div>
                ))}
              </div>
            </ScrollReveal>
          </div>
        </div>
      </section>
    </div>
  );
}
